import React, { FC } from 'react';
import Masonry from 'react-masonry-css';

const MasonryWrapper: FC = ({ children }) => {
  const breakpointColumnsObj = {
    default: 3,
    1280: 3,
    1024: 2,
    768: 1,
  };

  return (
    <Masonry className={'my-masonry-grid'} columnClassName={'my-masonry-grid_column'} breakpointCols={breakpointColumnsObj}>
      {children}
    </Masonry>
  );
};

export default MasonryWrapper;
